
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket-videos/[...slug]",
      function () {
        return require("private-next-pages/cricket-videos/[...slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket-videos/[...slug]"])
      });
    }
  